export const APP = 'APP';
export const PROFILE = 'PROFILE';
export const THEME = 'THEME';